import get from 'lodash.get';
let fieldId = 0;
export function getError(isSubmitted, name, touched, errors) {
  return isSubmitted || get(touched, name) ? get(errors, name) : undefined;
}
export function getFieldId(fieldName) {
  return `${fieldName}-${fieldId++}`;
}
//# sourceMappingURL=index.js.map